import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function RHFCardField({ name, helperText, slotProps, type = 'text', ...other }) {
  const { t } = useTranslate();

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          error={!!error}
          helperText={t(error?.message) ?? helperText}
          slotProps={{
            ...slotProps?.textField,
            htmlInput: {
              ...slotProps?.htmlInput,
              ...(type === 'tel' && { inputMode: 'decimal', pattern: '[0-9]' }),
            },
          }}
          {...other}
        />
      )}
    />
  );
}
